module.exports = __webpack_public_path__ + "img/enhance_your_experience_1024.2accfaea.png";